"use strict";
// import process from 'process'
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    // default run environment
    env: 'PROD',
    init() {
        this.setEnv();
    },
    readEnv(name) {
        return null;
        // NOTE: Below: "process.env[`${name}` as const]" don't works 
        /*if (process.env[name]) {  // common configuration setting
          return process.env[`${name}` as const]
        } else {  // running env related configuration setting
          const envName = `${this.env}_${name}`
          return process.env[`${envName}` as const]
        }
        */
    },
    readLocalStorage(name) {
        return { name };
    },
    readUrlQuery(name) {
        return { name };
    },
    get(name) {
        // TODO: handle all possible sources; now only .env file
        return this.readEnv(name);
    },
    set(name, value) {
        return { name, value };
    },
    setEnv() {
        this.env = process.env.DEV ? 'DEV' : (process.env.PROD ? 'PROD' : 'STAGE');
    } /*,
    stage(name?: string): string|null {
      if (!process.env.DEV) { // not dev mode -> production or stage mode
        if (window.location.host.includes('dev')) { // `dev` present on hostname (ex. dev-admin.ttr.fm) -> stage mode
          if (name && name.includes('URL_')) {  // requested configuration is 'URL_' kind (ex. 'URL_API')
            name = 'STAGE_' + name  // for stage mode - append 'STAGE_' (ex. 'STAGE_URL_API')
          }
        }
      }
      return name || null
    }*/
};
